<c-header configuration="$ctrl.headerConfig"></c-header>
<c-global-notification></c-global-notification>
<div class="flex-container">
    <div class="flex-overlay" ng-click="$ctrl.showNavigation(false)"></div>
    <nav class="flex-navigation">
        <div class="flex-navigation" tabindex="0"></div>
    </nav>
    <section ng-if="$ctrl.configuration.navigation" class="flex-content" ui-view tabindex="0"></section>
    <c-horizontal-resizer/>
</div>
<section class="flex-single-content">
    <ui-view ng-if="$ctrl.configuration.main" ng-class="$ctrl.theme" tabindex="0"></ui-view>
</section>
<footer ng-if="$ctrl.showFooter" c-status-bar></footer>
<div class="main"><!-- fake div for popupservice --></div>
